import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function SocialProof() {
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5
    }
  };
  const testimonials = [{
    name: 'Mariana',
    text: 'Pensé que iba a ser otro recetario más, pero me sorprendió muchísimo. Las recetas son fáciles y están buenísimas.',
    rating: 5
  }, {
    name: 'Sofía',
    text: 'La parte de postres me encantó. Me ayudó a bajar muchísimo el consumo de azúcar sin sentir que me estaba privando.',
    rating: 5
  }, {
    name: 'Diana',
    text: 'Soy malísima cocinando y aun así pude hacer varias recetas. Está todo súper claro.',
    rating: 5
  }, {
    name: 'Fernanda',
    text: 'Lo mejor es que tengo muchísimas ideas en un solo lugar. Ya no pierdo tiempo pensando qué comer.',
    rating: 5
  }, {
    name: 'Laura',
    text: 'Muy variado, fácil de seguir y práctico para el día a día.',
    rating: 5
  }];
  return <section className="py-16 px-4 bg-white" data-id="element-185">
      <div className="max-w-6xl mx-auto" data-id="element-186">
        <motion.h2 {...fadeInUp} className="font-playfair text-3xl md:text-5xl font-bold text-center text-dark mb-12" data-id="element-187">
          Lo que están diciendo nuestras clientas
        </motion.h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-188">
          {testimonials.map((testimonial, index) => <motion.div key={index} {...fadeInUp} transition={{
          delay: index * 0.1
        }} className="bg-cream rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-189">
              <div className="flex gap-1 mb-4" data-id="element-190">
                {[...Array(testimonial.rating)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-500 text-yellow-500" data-id="element-191" />)}
              </div>

              <p className="text-dark/80 mb-4 leading-relaxed" data-id="element-192">
                "{testimonial.text}"
              </p>

              <p className="font-semibold text-dark" data-id="element-193">— {testimonial.name}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}